export const MANAGED_PAYMENT_ALLOWED_ROLES = ['owner', 'admin']